var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('GeneralTable',{attrs:{"classifiers":_vm.classifiers,"userData":_vm.userData,"getGeneralSummaryTable":_vm.getGeneralSummaryTable}}),_c('GeneralChart',{staticClass:"mt-8",attrs:{"classifiers":_vm.classifiers,"isDataLoaded":_vm.isDataLoaded,"getColumnSortedDataTableInfo":_vm.getColumnSortedDataTableInfo}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }